/*!
  _   _  ___  ____  ___ ________  _   _   _   _ ___   
 | | | |/ _ \|  _ \|_ _|__  / _ \| \ | | | | | |_ _| 
 | |_| | | | | |_) || |  / / | | |  \| | | | | || | 
 |  _  | |_| |  _ < | | / /| |_| | |\  | | |_| || |
 |_| |_|\___/|_| \_\___/____\___/|_| \_|  \___/|___|
                                                                                                                                                                                                                                                                                                                                       
=========================================================
* Horizon UI - v1.1.0
=========================================================

* Product Page: https://www.horizon-ui.com/
* Copyright 2023 Horizon UI (https://www.horizon-ui.com/)

* Designed and Coded by Simmmple

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

// Chakra imports
import { 
  Box, 
  SimpleGrid,
  Button,
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Flex,
  Text,
  useToast
} from "@chakra-ui/react";
import DevelopmentTable from "views/admin/dataTables/components/DevelopmentTable";
import CheckTable from "views/admin/dataTables/components/CheckTable";
import ColumnsTable from "views/admin/dataTables1/components/ColumnsTable";
import ComplexTable from "views/admin/dataTables/components/ComplexTable";
import {
  columnsDataDevelopment,
  columnsDataCheck,
  columnsDataColumns,
  columnsDataComplex,
} from "views/admin/dataTables/variables/columnsData";
import tableDataDevelopment from "views/admin/dataTables/variables/tableDataDevelopment.json";
import tableDataCheck from "views/admin/dataTables/variables/tableDataCheck.json";
import tableDataColumns from "views/admin/dataTables/variables/tableDataColumns.json";
import tableDataComplex from "views/admin/dataTables/variables/tableDataComplex.json";
import React from "react";
import { commonFetch } from '@/utils/util'

export default function Settings() {
  // Chakra Color Mode
  const { isOpen, onOpen, onClose } = useDisclosure()
  const toast = useToast()
  const btnRef = React.useRef()

  const onDetail = (payOrderId) => {
    console.log(payOrderId)
    // commonFetch({
    //   url: `/api/consumption/pay/${payOrderId}`,
    //   method: 'get',
    // }, toast).then(res => {
    //   onOpen()
    // })
  }

  return (
    <>
      <Box pt={{ base: "130px", md: "100px", xl: "100px" }}>
        <SimpleGrid
          mb='20px'
          // columns={{ sm: 1, md: 2 }}
          spacing={{ base: "20px", xl: "20px" }}>
          {/* <DevelopmentTable
            columnsData={columnsDataDevelopment}
            tableData={tableDataDevelopment}
          />
          <CheckTable columnsData={columnsDataCheck} tableData={tableDataCheck} /> */}
          <ColumnsTable
            columnsData={columnsDataColumns}
            tableData={tableDataColumns}
            onDetail={onDetail}
          />
          {/* <ComplexTable
            columnsData={columnsDataComplex}
            tableData={tableDataComplex}
          /> */}
        </SimpleGrid>
      </Box>

      <Drawer
        size="lg"
        isOpen={isOpen}
        placement="right"
        finalFocusRef={btnRef}
        onClose={onClose}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>订单详情</DrawerHeader>
          <DrawerBody>
            <Flex mb="15px">
              <Box flex={1}>
                <Text>服务商号：</Text>
              </Box>
              <Box flex={1}>
                <Text>支付订单号：</Text>
              </Box>
            </Flex>
            <Flex mb="15px">
              <Box flex={1}>
                <Text>商户号：M1679219294</Text>
              </Box>
              <Box flex={1}>
                <Text>商户订单号：火锅鸡</Text>
              </Box>
            </Flex>
            <Flex mb="15px">
              <Box flex={1}>
                <Text>商户名称：火锅鸡</Text>
              </Box>
              <Box flex={1}>
                <Text>应用APPID：676ce493e4b0e42ba622b273</Text>
              </Box>
            </Flex>
            <Flex mb="15px">
              <Flex flex={1} align={'center'}>
                <Box>
                  <Text>订单状态：</Text>
                </Box>
                <Box bg="orange.500" textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
                  <Text color={'#fff'} fontSize="sm" fontWeight="700">
                    支付中
                  </Text>
                </Box>
              </Flex>
              <Flex flex={1} align={'center'}>
                <Box>
                  <Text>支付金额：</Text>
                </Box>
                <Box bg="green.500" textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
                  <Text color={'#fff'} fontSize="sm" fontWeight="700">
                    0.01
                  </Text>
                </Box>
              </Flex>
            </Flex>
            <Flex mb="15px">
              <Flex flex={1} align={'center'}>
                <Box>
                  <Text>手续费：</Text>
                </Box>
                <Box bg="pink.500" textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
                  <Text color={'#fff'} fontSize="sm" fontWeight="700">
                    0
                  </Text>
                </Box>
              </Flex>
              <Box flex={1}>
                <Text>商家费率：0.01%</Text>
              </Box>
            </Flex>
            <Flex mb="15px">
              <Box flex={1}>
                <Text>支付错误码：</Text>
              </Box>
              <Box flex={1}>
                <Text>支付错误描述：</Text>
              </Box>
            </Flex>
            <Flex mb="15px">
              <Box flex={1}>
                <Text>订单失效时间：2024-12-27 11:48:08</Text>
              </Box>
              <Box flex={1}>
                <Text>支付成功时间：2024-12-27 11:48:08</Text>
              </Box>
            </Flex>
            <Flex mb="20px">
              <Box flex={1}>
                <Text>创建时间：2024-12-27 11:48:08</Text>
              </Box>
              <Box flex={1}>
                <Text>更新时间：2024-12-27 11:48:08</Text>
              </Box>
            </Flex>

            <Box height={'1px'} w={"100%"} bg="gray.200" mb={"20px"}></Box>

            <Flex mb="15px">
              <Box flex={1}>
                <Text>商品标题：</Text>
              </Box>
              <Box flex={1}>
                <Text>商品描述：</Text>
              </Box>
            </Flex>
            <Flex mb="15px">
              <Box flex={1}>
                <Text>接口代码：</Text>
              </Box>
              <Box flex={1}>
                <Text>货币代码：</Text>
              </Box>
            </Flex>
            <Flex mb="15px">
              <Box flex={1}>
                <Text>支付方式：</Text>
              </Box>
              <Box flex={1}>
                <Text>客户端IP：</Text>
              </Box>
            </Flex>
            <Flex mb="15px">
              <Box flex={1}>
                <Text>用户标识：</Text>
              </Box>
              <Box flex={1}>
                <Text>渠道订单号：</Text>
              </Box>
            </Flex>
          </DrawerBody>
          <DrawerFooter>
            {/* <Button variant="outline" mr={3} onClick={onClose}>
              Cancel
            </Button> */}
            <Button colorScheme="brand" onClick={onClose}>确定</Button>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}
